<div class="device-wrapper">

    <div class="device" data-device="iPhoneX" data-orientation="portrait"
        data-color="black">
        <div class="screen">
        
            <div class="preview-img">
                <img *ngIf="this.event?.image" class="width100 full"
                    src="{{this.event?.image.url}}" alt="">
                <img *ngIf="!this.event?.image" class="width100 full"
                    src="../../../../../../assets//placeholders/eventImage.png" alt="">
            </div>
            <div class="header" >
                <h4>{{this.event?.title }}</h4>
                <img src="../../../../../assets/icons/close.png" class="closeBtn" alt="">
            </div>
 
            <div class="redBox">
                <div class="additional-info highlight"
                    *ngIf="(this.event?.eventDiscount !='SERVICE_PLUS')&& (this.event?.savingInPercent != null)">
                    {{event?.discountLabel}}</div>

                <div class="additional-info highlight"
                    *ngIf="(this.event?.eventDiscount =='SERVICE_PLUS') && (this.event?.savingInPercent != null)">
                    Exklusiver Vorteil
                </div>
            </div>

            <div class="reservations">
                <div class="wrapper" >
                    <div class="minus">
                        -
                    </div>
      
                    <h3>1</h3>
                    <div class="plus">
                        +
                    </div>
    
                    <h3>Max Mustermann</h3>
                </div>
            </div>
            <div class="divider"></div>

            <div class="description">
                <h6> <b>Vorteilsbeschreibung</b> </h6>
                <div [innerHtml]="this.event?.description">
                
                </div>
            </div>
            <div class="actionButton">
                <div class="btn">
                    Reservieren
                </div>
            </div>
        </div>
        <div class="button">
            <!-- <You can hook the "home button" to some JavaScript events or just remove it  -->
        </div>
    </div> 
</div>